import React from 'react'

type Props = {
  dirty: boolean
  lastSavedAt: number | null
  wordCount: number
  className?: string
}

function formatTime(ts: number): string {
  try {
    const d = new Date(ts)
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  } catch {
    return ''
  }
}

export default function SaveWordStatus({ dirty, lastSavedAt, wordCount, className = '' }: Props) {
  return (
    <div className={"flex items-center gap-3 text-xs " + className}>
      <div className="flex items-center gap-1 text-white/70">
        <span className={`inline-block h-2.5 w-2.5 rounded-full ${dirty ? 'bg-amber-400' : 'bg-emerald-400'}`} />
        <span>{dirty ? 'Unsaved' : `Saved${lastSavedAt ? ' ' + formatTime(lastSavedAt) : ''}`}</span>
      </div>
      <div className="text-white/70">{wordCount} {wordCount === 1 ? 'word' : 'words'}</div>
    </div>
  )
}

